import { parseMarkdown } from './text-parsing'

export const scrollToElement = (
  element: HTMLElement,
  onScrollEnd: () => void,
  alignment?: ScrollLogicalPosition
) => {
  const dataAlignment = element.getAttribute('data-alignment')
  const targetAlignment = dataAlignment ?? alignment

  // Workaround for a terrible way Chromium-based browsers handle scrollIntoView
  // Disables IntersectionObserver and other scroll-related events temporarily
  document.body.classList.add('scrolling')

  const elementPosition = element.getBoundingClientRect()
  const elementOffsetTop = elementPosition.top + window.pageYOffset
  let scrollPosition = 0

  if (targetAlignment === 'center') {
    scrollPosition =
      elementOffsetTop + (-window.innerHeight + elementPosition.height - 70) / 2
  } else {
    scrollPosition = elementOffsetTop - 70
  }

  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth',
  })

  setTimeout(() => {
    document.body.classList.remove('scrolling')

    if (onScrollEnd) {
      onScrollEnd()
    } else {
      console.log('onScrollEnd not defined')
    }
  }, 1000)
}

export const buildObjects = <T extends object>(data: {
  values: Array<string[]>
}) => {
  const dataCopy = data.values.slice()
  const columnNames = dataCopy.shift() as string[]

  const getColumnData = (columnName: string, value: string) => {
    return columnName === 'content' ? parseMarkdown(value) : value
  }

  const parsedData = dataCopy.map((row, rowIndex) =>
    row.reduce(
      (acc, value, index) => {
        const columnName = columnNames[index].toLowerCase()

        if (!value) {
          return acc
        }

        return {
          ...acc,
          [columnName]:
            acc[columnName as keyof typeof acc] &&
            Array.isArray(acc[columnName as keyof typeof acc])
              ? [
                  ...(acc[columnName as keyof typeof acc] as unknown as any[]),
                  getColumnData(columnName, value),
                ]
              : acc[columnName as keyof typeof acc]
              ? [
                  acc[columnName as keyof typeof acc],
                  getColumnData(columnName, value),
                ]
              : getColumnData(columnName, value),
        }
      },
      { id: rowIndex + 1 } as T
    )
  )

  return parsedData
}
